import {caracteristicasFields, contrapartesFields, caracteristicasRadios} from "../../pages/MotorCadastros/CadastroCaracteristicas/components/CaracteristicasSection/constants"
import {ofertaFields, ofertaRadios, publicoAlvoRadios, publicoDatas, coordenadoresFields} from "../../pages/MotorCadastros/CadastroCaracteristicas/components/OfertaSection/constants"
import {garantiasRows} from "../../pages/MotorCadastros/CadastroCaracteristicas/components/GarantiasSection/constants"
import {DEFAULT_RADIO_BOOLEAN} from "../../components/FieldRenderer"


const EMPRESAS_SAMPLE = [
    {label: "BANCO DO BRASIL S.A. 00.000.000/0001-91", value: "00000000000191"},
    {label: "BANCO DE BRASÍLIA S.A. 00.000.208/0001-00", value: "00000208000100"},
    {label: "BANCO BRADESCO S.A. 60.746.948/0001-12", value: "60746948000112"},
    {label: "BANCO ITAÚ UNIBANCO S.A. 60.701.190/0001-04", value: "60701190000104"},
    {label: "BANCO BTG PACTUAL S.A. 30.306.294/0001-45", value: "30306294000145"},
    {label: "XP INVESTIMENTOS S.A. 02.332.886/0001-04", value: "02332886000104"},
]
const randomEmpresa = () => EMPRESAS_SAMPLE[Math.floor(Math.random() * EMPRESAS_SAMPLE.length)] || EMPRESAS_SAMPLE[0]

const randomDecimal = () => (Math.random() * 1000).toFixed(2)
const randomNumber = (digits = 4) => {
    const max = 10 ** digits
    return String(Math.floor(Math.random() * max)).padStart(digits, "0")
}
const randomDate = () => {
    const start = new Date(2020, 0, 1).getTime()
    const end = new Date(2025, 11, 31).getTime()
    const date = new Date(start + Math.random() * (end - start))
    const dd = String(date.getDate()).padStart(2, "0")
    const mm = String(date.getMonth() + 1).padStart(2, "0")
    const yyyy = date.getFullYear()
    return `${dd}/${mm}/${yyyy}`
}

const randomChoice = (arr = []) => {
    if (!arr.length) return ""
    return arr[Math.floor(Math.random() * arr.length)]
}

const pickOptionValue = (option, index = 0) => {
    if (option === undefined || option === null) return ""
    if (typeof option === "object") {
        if (option.value !== undefined) return option.value
        if (option.label !== undefined) return option.label
    }
    return `${option}` || `Valor ${index + 1}`
}

const randomNumeric = (maxLength = 4) => randomNumber(Math.max(Number(maxLength) || 4, 1))

const getValueByType = (field, index) => {
    if (field.maskType === "date") return randomDate()
    if (field.maskType === "decimal" || field.inputProps?.inputMode === "decimal") return randomDecimal()
    if (field.maskType === "cpfCnpj") return randomEmpresa()
    if (field.type === "radio") {
        const pick = randomChoice(field.items && field.items.length ? field.items : DEFAULT_RADIO_BOOLEAN)
        return pick?.value ?? field.defaultValue ?? ""
    }
    if (field.type === "select") {
        const option = randomChoice(field.options || []) ?? (field.options || [])[0]
        return pickOptionValue(option, index)
    }
    if (field.inputProps?.type === "url") return "https://site.com"
    if (field.inputProps?.inputMode === "numeric" || field.inputProps?.type === "number") {
        return randomNumeric(field.inputProps?.maxLength)
    }
    if (field.mask) {
        const digits = `${field.mask}`.replace(/\D/g, "").length
        return randomNumeric(digits || 4)
    }
    return `Valor ${index + 1}`
}

export const createAutofillHandlers = (setSectionField) => ({
    caracteristicas: () => {
        caracteristicasFields.forEach((field, index) => {
            if (field.key === "emissao") {
                setSectionField("caracteristicas", field.key, "")
                return
            }
            const value = getValueByType(field, index)
            if (field.maskType === "cpfCnpj") {
                setSectionField("caracteristicas", field.key, value.value)
                setSectionField("caracteristicas", `${field.key}Label`, value.label)
                setSectionField("caracteristicas", `${field.key}NaoCadastrado`, false)
            } else {
                setSectionField("caracteristicas", field.key, value)
            }
        })
        contrapartesFields.forEach((field, index) => {
            if (field.maskType === "cpfCnpj") {
                const emp = randomEmpresa()
                setSectionField("caracteristicas", field.key, emp.value)
                setSectionField("caracteristicas", `${field.key}Label`, emp.label)
                setSectionField("caracteristicas", `${field.key}NaoCadastrado`, false)
            } else {
                setSectionField("caracteristicas", field.key, getValueByType(field, index))
            }
        })
        caracteristicasRadios.forEach((radio) =>
            setSectionField(
                "caracteristicas",
                radio.key,
                randomChoice(radio.items || DEFAULT_RADIO_BOOLEAN)?.value || ""
            )
        )
    },
    oferta: () => {
        ofertaFields.forEach((field, index) => {
            const value = getValueByType(field, index)
            setSectionField("oferta", field.key, value)
        })
        ofertaRadios.forEach((radio) =>
            setSectionField(
                "oferta",
                radio.key,
                randomChoice(radio.items || DEFAULT_RADIO_BOOLEAN)?.value || ""
            )
        )
        publicoAlvoRadios.forEach((radio) =>
            setSectionField(
                "oferta",
                radio.key,
                randomChoice(radio.items || DEFAULT_RADIO_BOOLEAN)?.value || ""
            )
        )
        publicoDatas.forEach((field) => setSectionField("oferta", field.key, randomDate()))
        coordenadoresFields.forEach((field, index) => {
            if (field.maskType === "cpfCnpj") {
                const emp = randomEmpresa()
                setSectionField("oferta", field.key, emp.value)
                setSectionField("oferta", `${field.key}Label`, emp.label)
                setSectionField("oferta", `${field.key}NaoCadastrado`, false)
            } else if (field.inputProps?.inputMode === "numeric") {
                setSectionField("oferta", field.key, randomNumber(4))
            } else {
                setSectionField("oferta", field.key, `Valor ${index + 1}`)
            }
        })
    },
    garantias: () => {
        setSectionField("garantias", "tipoLastro", "Lastro")
        setSectionField("garantias", "contaVinculada", randomChoice(DEFAULT_RADIO_BOOLEAN)?.value || "")
        garantiasRows.forEach((row) => {
            setSectionField("garantias", `${row.key}Check`, true)
            setSectionField("garantias", row.key, randomDecimal())
            setSectionField("garantias", `${row.key}Valor`, randomDecimal())
        })
        setSectionField("garantias", "ltvNumerador", randomDecimal())
        setSectionField("garantias", "ltvDenominador", randomDecimal())
        setSectionField("garantias", "ltv", randomDecimal())
    },
})

export const generateCovenantAutofill = () => ({
    id: Date.now(),
    dataValidadeInicial: randomDate(),
    dataValidadeFinal: randomDate(),
    tipoCovenant: randomChoice([{value: "financeiro"}, {value: "operacional"}])?.value || "",
    clausula: "13.8.a",
    numerador: randomDecimal(),
    denominador: randomDecimal(),
    limite: "<=1,5",
    observacao: "Observação teste",
})

export const shouldEnableAutofill = () => process.env.REACT_APP_ENABLE_AUTOFILL === "true"

export const createInvalidFillHandlers = (setSectionField) => ({
    caracteristicas: () => {
        setSectionField("caracteristicas", "dataReferencia", "99/99/9999")
        setSectionField("caracteristicas", "dataDocumento", "99/99/9999")
        setSectionField("caracteristicas", "frequenciaJuros", "abc")
        setSectionField("caracteristicas", "frequenciaAmortizacao", String(Math.random()).slice(2, 5))
    },
    oferta: () => {
        setSectionField("oferta", "dataRequerimento", "99/99/9999")
        setSectionField("oferta", "dataRegistro", "99/99/9999")
        setSectionField("oferta", "dataInicioOferta", "32/13/2020")
    },
    garantias: () => {
        setSectionField("garantias", "ltvNumerador", "abc")
        setSectionField("garantias", "ltvDenominador", "xyz")
        setSectionField("garantias", "ltv", String(Math.random() * 1000))
    },
})

export const createClearHandlers = (setSectionField) => ({
    caracteristicas: () => {
        caracteristicasFields.forEach((field) => setSectionField("caracteristicas", field.key, ""))
        contrapartesFields.forEach((field) => {
            setSectionField("caracteristicas", field.key, "")
            setSectionField("caracteristicas", `${field.key}Label`, "")
            setSectionField("caracteristicas", `${field.key}NaoCadastrado`, false)
        })
        caracteristicasRadios.forEach((radio) => setSectionField("caracteristicas", radio.key, ""))
    },
    oferta: () => {
        ofertaFields.forEach((field) => setSectionField("oferta", field.key, ""))
        publicoAlvoRadios.forEach((radio) => setSectionField("oferta", radio.key, ""))
        publicoDatas.forEach((field) => setSectionField("oferta", field.key, ""))
        coordenadoresFields.forEach((field) => {
            setSectionField("oferta", field.key, "")
            setSectionField("oferta", `${field.key}Label`, "")
            setSectionField("oferta", `${field.key}NaoCadastrado`, false)
        })
    },
    garantias: () => {
        garantiasRows.forEach((row) => {
            setSectionField("garantias", `${row.key}Check`, false)
            setSectionField("garantias", row.key, "")
            setSectionField("garantias", `${row.key}Valor`, "")
        })
        setSectionField("garantias", "ltvNumerador", "")
        setSectionField("garantias", "ltvDenominador", "")
        setSectionField("garantias", "ltv", "")
    },
})
